import { Textarea } from '@/presentation/components/textarea'
import type { HTMLAttributes } from 'react'
import type { AutoFormWidgetsProps } from '../autoForm'
import { Field } from '../field'
import { FieldControl } from '../fieldControl'
import { FieldLabel } from '../label'
import { FieldMessage } from '../message'

type TextareaWidgetProps = AutoFormWidgetsProps & {
  initialValue?: HTMLAttributes<HTMLInputElement>['defaultValue']
}

export const TextareaWidget = (props: TextareaWidgetProps) => {
  return (
    <Field path={props.path} className={props.classNames?.root}>
      <FieldLabel>{props.options?.label as string}</FieldLabel>
      <FieldControl>
        <Textarea
          className="bg-white"
          placeholder={props.options?.placeholder as string | undefined}
          defaultValue={props.initialValue}
        />
      </FieldControl>
      <FieldMessage />
    </Field>
  )
}
